import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';

/** Página 404: antes cualquier enlace roto mandaba a la landing sin aviso, incluso con sesión. */
const NotFound = () => {
  const { user } = useAuth();
  const home = user ? '/app/dashboard' : '/';
  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center px-4" data-testid="not-found">
      <div className="text-center max-w-md">
        <img src="/brand/app-icon-square.webp" alt="ONOR CODE" className="h-16 w-16 mx-auto mb-6 rounded" />
        <p className="text-primary text-xs uppercase tracking-wider font-bold">Error 404</p>
        <h1 className="font-display font-bold text-3xl text-white uppercase mt-2">Esta página no existe</h1>
        <p className="text-zinc-400 text-sm mt-3">El enlace está roto o la página cambió de lugar.</p>
        <Link to={home} className="inline-block mt-6">
          <Button className="btn-primary px-6">{user ? 'Ir a mi inicio' : 'Ir a la página principal'}</Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
